/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';
import { Variance } from '@touchplan/common';
import { FancyAction } from '../base/FancyAction';
import { FancyFirebaseList } from '../base/FancyFirebaseList';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';

export class VarianceList extends FancyFirebaseList<Variance, FancyAction> {
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, FancyAction, fancyJoins);
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		return new Variance(action.payload.val(), action.key);
	}
	public $$updated(child: Variance, action: AngularFireAction<DatabaseSnapshot<any>>) {
		child.update(action.payload.val());
	}
}
